import {Adresse} from "@domain/profil/adresse";
import {LegacyFloatLabelType as FloatLabelType} from "@angular/material/legacy-form-field";
import {environment} from "@environments/environment";
import {LieuParam} from "@domain/common/lieu/lieu-param";

/**
 * Paramétrage pour la partie frais du lieu
 */
export class LieuParamFrais extends LieuParam {
    /** {@inheritDoc} */
    isSaisieAutorisee = () => true;

    /** {@inheritDoc} */
    isShowAdresseBaseAndEtablissement = true;

    /** {@inheritDoc} */
    titleAdresseTab = 'lieu.tabs.mesAdresses';

    /** {@inheritDoc} */
    libelleInputFormatOnInit = (data: Adresse) => {
        //Si on a pas de libelle
        if (data.libelle == null || data.libelle == '') {
            //On formate l'adresse
            return `${data.rue ? data.rue + ', ' : ''} ${data.codePostal ? data.codePostal + ' ' : ''} ${data.ville}, ${data.pays}`;
        }

        return data.libelle;
    }

    /** {@inheritDoc} */
    libelleInputFormatOnSelect = (data: { adresse: string }) => data.adresse;

    /** {@inheritDoc} */
    placeHolder = (libelleAdresse: String,isDisabled: boolean) => "ndf.frais.depart";

    /** {@inheritDoc} */
    floatLabel: FloatLabelType = "always";

    /** {@inheritDoc} */
    mapper = (data: any) => {
        return {
            //On doit renvoyer un lieu de type Adresse qui est une projection de la table ns_vm_localisation
            //Il faut récupérer l'id pour la localisation selon l'onglet mes adresses/établissement/saisie
            id: data.objet.idLocalisation ?? data.objet.idLoc ?? data.objet.idAdresse ?? data.objet.id,
            idAdresse: data.objet.idLocalisation ?? data.objet.idLoc ?? data.objet.idAdresse ?? data.objet.id,
            //Informations de géolocalisation
            latitude: data.objet.adresse?.latitude ?? data.objet.latitude,
            longitude: data.objet.adresse?.longitude ?? data.objet.longitude,
            //Utilisé pour le libellé
            libelleEtablissement: data.objet?.libelle,
            rue: data.objet?.rue,
            codePostal: data.objet?.codePostal,
            //Selon l'onglet, on récupère l'information sur un objet différent
            ville: data.objet?.ville ?? data.adressePays?.ville ?? data.objet.adresse?.ville,
            pays: data.objet?.pays ?? data.adressePays?.pays ?? data.objet.adresse?.pays,
            codePays: data.objet?.codePays3 ?? data.objet?.codePays,
        };
    }

    /** {@inheritDoc} */
    isBoutonValider = false;

    /** {@inheritDoc} */
    isGeolocaliserWithoutRue = true;

    /** {@inheritDoc} */
    isGeolocaliserOnSelect = true;

    /** {@inheritDoc} */
    isShowLieuxRecents = true;

    /**
     * Constructeur
     * */
    constructor(idObject: number,idUser: number) {
        super();

        this.urlAdresse = `${environment.baseUrl}/controller/NDF/${idObject}/getListeLieux`;

        //URL pour charger les lieux récents de l'utilisateur
        this.urlLieuxRecents = `${environment.baseUrl}/controller/Adresse/${idUser}/getLieuxRecents`;

        this.idUser = idUser;
    }
}